import { Component, OnInit  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PayComponent } from '../components/pay.component';
import { BuyComponent } from '../components/buy.component';
import { TopUpComponent } from '../components/top-up.component';
import { WithdrawComponent } from '../components/withdraw.component';
import { TransactionsHistoryComponent } from '../components/transactions-history.component';
import { HomeNavigationService } from '../home-navigation.service';
import { SessionService } from '../services/session.service';
import { environment } from '../../environments/environment';
@Component({
standalone:true,
imports:[
  CommonModule,
  PayComponent,
  BuyComponent,
  TopUpComponent,
  WithdrawComponent,
  TransactionsHistoryComponent
],
template:
  `
    <div *ngIf="showPage">
      <div class="home-fixed">
        <div class="balance">
          <div style="font-size:1rem;color:#aaa">Platform Credit</div>
          <h1>R{{ walletBalance | number:'1.2-2' }}</h1>
          <div class="warning-text"  *ngIf="currentAmount && currentAmount"> walletBalance">
            Insufficient funds
          </div>
        </div>
        <div class="actions">
          <div class="action"
            *ngFor="let a of actions"
            [class.active]="selected===a"
            (click)="selectAction(a)">
            <div class="circle">
              <img [src]="a.icon" class="action-img">
            </div>
            <div>{{a.name}}</div>
          </div>
        </div>
      </div>
      <div class="home-card">
        <app-pay *ngIf="selected.name==='Pay'" [walletBalance]="walletBalance" (amountChanged)="currentAmount = $event" (viewHistory)="selected = actions[4]"></app-pay>
        <app-buy *ngIf="selected.name==='Buy'" [walletBalance]="walletBalance" (amountChanged)="currentAmount = $event" (viewHistory)="selected = actions[4]"></app-buy>
        <app-topUp *ngIf="selected.name==='Top Up'" [walletBalance]="walletBalance" (amountChanged)="currentAmount = $event" (viewHistory)="selected = actions[4]"></app-topUp>
        <app-withdraw *ngIf="selected.name==='Withdraw'" [walletBalance]="walletBalance" (amountChanged)="currentAmount = $event" (viewHistory)="selected = actions[4]"></app-withdraw>
        <app-transactionsHistory *ngIf="selected.name==='History'"></app-transactionsHistory>
      </div>
    </div>

    <div class="overlay" *ngIf="showErrorPopup">
      <div class="alert-modal">
        <p class="pin-text">
            {{ errorMessage }}
        </p>
        <div class="btns">
          <button
            class="primary"
            (click)="closeErrorPopup()">
            Close
          </button>
        </div>
      </div>
    </div>
  `
})
export class HomePage{
   constructor(private homeNavigation: HomeNavigationService, 
               private sessionService: SessionService,) {}
  showPage = false;
  showErrorPopup = false;
  errorMessage = '';
  sessionToken = '';
  walletBalance = 0;
  whatsAppUrl = environment.whatsapp_url;
  // ngOnInit() {
  //   if (!this.sessionService.hasSession()) {
  //     window.location.href = this.whatsAppUrl;
  //     return;
  //   }
  //   this.walletBalance = this.sessionService.getWalletBalance();
  //   this.showPage = true;
  // }
  
  actions=[
  {
    name:'Pay',
    icon:'assets/images/Pay.png'
  },
  {
    name:'Buy',
    icon:'assets/images/Buy.png'
  },
  {
    name:'Top Up',
    icon:'assets/images/Topup.png'
  },
  {
    name:'Withdraw',
    icon:'assets/images/Withdraw.png'
  },
  {
    name:'History',
    icon:'assets/images/History.png'
  }
  ];
  selected=this.actions[4];
  
  currentAmount: number | null = null;

   ngOnInit() {

    if (!this.sessionService.hasSession()) {
      window.location.href = this.whatsAppUrl;
      return;
    }

    this.walletBalance = this.sessionService.getWalletBalance();
    this.showPage = true;

    // Listen for navigation changes from AppComponent
    this.homeNavigation.tabSelected$.subscribe(tab => {

      const action = this.actions.find(a => a.name === tab);

      if (action) {
        this.selected = action;
        this.currentAmount = null;
      }

    });
  }
  
  private setSelectedAction(action: any) {
  this.selected = action;
  this.currentAmount = null;
}

  selectAction(action: any) {
     this.setSelectedAction(action);
      // Only notify the service when the user clicks
  this.homeNavigation.selectTab(action.name);
    this.currentAmount = null; // or 0 if you prefer
  }
}
